import {
  Category,
  StockLookupRedirectResponse,
  StockLookupSuccessResponse,
} from '../py-generated/datalouder/stock/types';
import {
  FetchAllStocksResponseBody,
  LookupRequestParameters,
} from '../shared/types';
import { apiv2Url } from './config';
import { getPromise, handleJSONResponse } from './utils';

export const isStockLookupRedirectResponse = (
  response: StockLookupSuccessResponse | StockLookupRedirectResponse
): response is StockLookupRedirectResponse => {
  return (response as StockLookupRedirectResponse).ticker !== undefined;
};

const lookup = async (
  stockCode: string,
  category?: string
): Promise<StockLookupSuccessResponse | StockLookupRedirectResponse> => {
  return await getPromise<
    LookupRequestParameters,
    StockLookupSuccessResponse | StockLookupRedirectResponse
  >(`${apiv2Url}/lookup`, { stockCode, category });
};

const listStocksByIndustries = (
  category: Category,
  industryId: string,
  subIndustryId: string
): Promise<[string[], string[]]> =>
  getPromise(`${apiv2Url}/stock-profile/industry-stocks`, {
    category,
    industryId,
    subIndustryId,
  });

const queryStockProfile = (
  category: Category,
  ticker: string,
  language: string
): Promise<any> =>
  getPromise(`${apiv2Url}/stock-profile/${category}/${ticker}/${language}`, {});

/**
 * No need to use getPromise function due to it is a public
 * URL and it doesn't need authorization.
 */
const fetchAllStocks = (category: Category) =>
  fetch(
    `https://datalouder-prod-publicbucket-l0nwlk2odns3.s3.ap-east-1.amazonaws.com/stocks/${category}.json`
  ).then(handleJSONResponse<FetchAllStocksResponseBody>());

export default {
  lookup,
  listStocksByIndustries,
  queryStockProfile,
  fetchAllStocks,
};
